
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('advanced-notes') && (binding.modules['advanced-notes'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-advanced-notes' */
            'partner/modules/advanced-notes/advanced-notes.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'advanced-notes',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/advanced-notes'
    });
        

    isNotRegistered('allowable-freight') && (binding.modules['allowable-freight'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-allowable-freight' */
            'partner/modules/allowable-freight/allowable-freight.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'allowable-freight',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/allowable-freight'
    });
        

    isNotRegistered('ari-search-results') && (binding.modules['ari-search-results'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-ari-search-results' */
            'partner/modules/ari-search-results/ari-search-results.tsx'),
        $type: 'contentModule',
        da: [{name:'ariResults',  path:'actions/search-models.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'ari-search-results',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ari-search-results'
    });
        

    isNotRegistered('b2b-account-management-address') && (binding.modules['b2b-account-management-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-b2b-account-management-address' */
            'partner/modules/b2b-account-management-address/b2b-account-management-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'b2b-account-management-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/b2b-account-management-address'
    });
        

    isNotRegistered('b2b-checkout-billing-address') && (binding.modules['b2b-checkout-billing-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-b2b-checkout-billing-address' */
            'partner/modules/b2b-checkout-billing-address/b2b-checkout-billing-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'b2b-checkout-billing-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/b2b-checkout-billing-address'
    });
        

    isNotRegistered('back-order-list') && (binding.modules['back-order-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-back-order-list' */
            'partner/modules/back-order-list/back-order-list.tsx'),
        $type: 'contentModule',
        da: [{name:'backOrderResults',  path:'actions/get-backorder-list.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'back-order-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/back-order-list'
    });
        

    isNotRegistered('cart-line-comment') && (binding.modules['cart-line-comment'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart-line-comment' */
            'partner/modules/cart-line-comment/cart-line-comment.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'cart-line-comment',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cart-line-comment'
    });
        

    isNotRegistered('checkout-section-container-w-payment-selector') && (binding.modules['checkout-section-container-w-payment-selector'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-section-container-w-payment-selector' */
            'partner/modules/checkout-section-container-w-payment-selector/checkout-section-container-w-payment-selector.tsx'),
        $type: 'containerModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'invoiceAccountInfo',  path:'actions/get-invoice-account.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-section-container-w-payment-selector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-section-container-w-payment-selector'
    });
        

    isNotRegistered('contracts-account-page') && (binding.modules['contracts-account-page'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-contracts-account-page' */
            'partner/modules/contracts-account-page/contracts-account-page.tsx'),
        $type: 'contentModule',
        da: [{name:'contractList',  path:'actions/get-contract-list.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'contracts-account-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/contracts-account-page'
    });
        

    isNotRegistered('education-training') && (binding.modules['education-training'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-education-training' */
            'partner/modules/education-training/education-training.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'courseResults',  path:'actions/get-education-courses.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'education-training',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/education-training'
    });
        

    isNotRegistered('eve-business-partners') && (binding.modules['eve-business-partners'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-business-partners' */
            'partner/modules/eve-business-partners/eve-business-partners.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-business-partners',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-business-partners'
    });
        

    isNotRegistered('eve-business-sign-up') && (binding.modules['eve-business-sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-business-sign-up' */
            'partner/modules/eve-business-sign-up/eve-business-sign-up.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-business-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-business-sign-up'
    });
        

    isNotRegistered('eve-checkout-shipping-address') && (binding.modules['eve-checkout-shipping-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-checkout-shipping-address' */
            'partner/modules/eve-checkout-shipping-address/eve-checkout-shipping-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-checkout-shipping-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-checkout-shipping-address'
    });
        

    isNotRegistered('eve-map') && (binding.modules['eve-map'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-map' */
            'partner/modules/eve-map/eve-map.tsx'),
        $type: 'contentModule',
        da: [{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-map',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-map'
    });
        

    isNotRegistered('eve-quick-order') && (binding.modules['eve-quick-order'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-quick-order' */
            'partner/modules/eve-quick-order/eve-quick-order.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'manufacturerCodes',  path:'actions/get-manufacturer-codes.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-quick-order',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-quick-order'
    });
        

    isNotRegistered('eve-search-result-container') && (binding.modules['eve-search-result-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-search-result-container' */
            'partner/modules/eve-search-result-container/eve-search-result-container.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'featureProduct',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'listPageState',  path:'modules/eve-search-result-container/list-page-state', runOn: 0},{name:'products',  path:'modules/eve-search-result-container/actions/get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'modules/eve-search-result-container/actions/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'modules/eve-search-result-container/actions/get-mapped-search-configuration', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-search-result-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-search-result-container'
    });
        

    isNotRegistered('gardner-theme') && (binding.modules['gardner-theme'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gardner-theme' */
            'partner/themes/gardner-theme/gardner-theme.tsx'),
        $type: 'themeModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', moduleName: 'search-result-container',runOn: 0},{name:'containerDetails',  path:'actions/get-order-details-additional-info.action', moduleName: 'order-details',runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', moduleName: 'checkout-order-confirmation',runOn: 0},{name:'enhancedDescription',  path:'actions/get-enhanced-description.action', moduleName: 'buybox',runOn: 0},{name:'invoiceAccountInfo',  path:'actions/get-invoice-account.action', moduleName: 'checkout',runOn: 0},{name:'manufacturerCodes',  path:'actions/get-manufacturer-codes.action', moduleName: 'search-result-container',runOn: 0}],
        definitionExtensions: ['active-image','b2b-requests-status','business-organization-list','buybox','cart-icon','cart','checkout-customer-account-payment','checkout-order-confirmation','checkout-payment-instrument','checkout-section-container','checkout','content-block','cookie-compliance','header','image-list','navigation-menu','order-confirmation','order-details','order-template-list','promo-banner','quickview','ratings-histogram','reviews-list','search-result-container','search','store-selector','text-block','write-review'],
        iNM: false,
        ns: '__local__',
        n: 'gardner-theme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'gardner-theme.theme.settings.json',
        md: 'src/themes/gardner-theme'
    });
        

    isNotRegistered('gardner-theme-b2c') && (binding.modules['gardner-theme-b2c'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gardner-theme-b2c' */
            'partner/themes/gardner-theme-b2c/gardner-theme-b2c.tsx'),
        $type: 'themeModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', moduleName: 'search-result-container',runOn: 0},{name:'enhancedDescription',  path:'actions/get-enhanced-description.action', moduleName: 'buybox',runOn: 0}],
        definitionExtensions: ['active-image','b2b-requests-status','business-organization-list','buybox','cart-icon','cart','checkout-shipping-address','checkout','content-block','cookie-compliance','header','image-list','navigation-menu','order-confirmation','order-template-list','promo-banner','quickview','ratings-histogram','reviews-list','search-result-container','search','store-selector','text-block','write-review'],
        iNM: false,
        ns: '__local__',
        n: 'gardner-theme-b2c',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'gardner-theme-b2c.theme.settings.json',
        md: 'src/themes/gardner-theme-b2c'
    });
        

    isNotRegistered('gdn-checkout-billing-address') && (binding.modules['gdn-checkout-billing-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-checkout-billing-address' */
            'partner/modules/gdn-checkout-billing-address/gdn-checkout-billing-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'gdn-checkout-billing-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gdn-checkout-billing-address'
    });
        

    isNotRegistered('gdn-google-analytic') && (binding.modules['gdn-google-analytic'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-google-analytic' */
            'partner/modules/gdn-google-analytic/gdn-google-analytic.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'gdn-google-analytic',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gdn-google-analytic'
    });
        

    isNotRegistered('gdn-invoice-details') && (binding.modules['gdn-invoice-details'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-invoice-details' */
            'partner/modules/gdn-invoice-details/gdn-invoice-details.tsx'),
        $type: 'contentModule',
        da: [{name:'gdnInvoiceDetails',  path:'actions/get-gdn-invoice-details.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'gdn-invoice-details',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gdn-invoice-details'
    });
        

    isNotRegistered('gdn-invoices-list') && (binding.modules['gdn-invoices-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-invoices-list' */
            'partner/modules/gdn-invoices-list/gdn-invoices-list.tsx'),
        $type: 'contentModule',
        da: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'customer',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'customerBalance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'getGdnInvoices',  path:'actions/get-gdn-invoices.action', runOn: 0},{name:'invoices',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'gdn-invoices-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gdn-invoices-list'
    });
        

    isNotRegistered('gdn-order-template') && (binding.modules['gdn-order-template'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-order-template' */
            'partner/modules/gdn-order-template/gdn-order-template.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplate',  path:'modules/gdn-order-template/actions/get-gdn-order-template', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'gdn-order-template',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gdn-order-template'
    });
        

    isNotRegistered('gdn-part-smart') && (binding.modules['gdn-part-smart'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-part-smart' */
            'partner/modules/gdn-part-smart/gdn-part-smart.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'gdn-part-smart',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gdn-part-smart'
    });
        

    isNotRegistered('gdn-product-specification') && (binding.modules['gdn-product-specification'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-product-specification' */
            'partner/modules/gdn-product-specification/gdn-product-specification.tsx'),
        $type: 'contentModule',
        da: [{name:'additionalMediaLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-additional-media-locations-for-selected-variant', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'gdn-product-specification',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gdn-product-specification'
    });
        

    isNotRegistered('gtm-body') && (binding.modules['gtm-body'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gtm-body' */
            'partner/modules/gtm-body/gtm-body.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'gtm-body',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gtm-body'
    });
        

    isNotRegistered('model-viewer') && (binding.modules['model-viewer'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-model-viewer' */
            'partner/modules/model-viewer/model-viewer.tsx'),
        $type: 'contentModule',
        da: [{name:'assemblyList',  path:'actions/get-model-assembly.action', runOn: 1},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'manufacturerCodes',  path:'actions/get-manufacturer-brand-name.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'model-viewer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/model-viewer'
    });
        

    isNotRegistered('order-history-search') && (binding.modules['order-history-search'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-history-search' */
            'partner/modules/order-history-search/order-history-search.tsx'),
        $type: 'contentModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'order-history-search',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/order-history-search'
    });
        

    isNotRegistered('order-level-comment') && (binding.modules['order-level-comment'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-level-comment' */
            'partner/modules/order-level-comment/order-level-comment.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'order-level-comment',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/order-level-comment'
    });
        

    isNotRegistered('order-scheduler') && (binding.modules['order-scheduler'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-scheduler' */
            'partner/modules/order-scheduler/order-scheduler.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'order-scheduler',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/order-scheduler'
    });
        

    isNotRegistered('order-upload') && (binding.modules['order-upload'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-upload' */
            'partner/modules/order-upload/order-upload.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'order-upload',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/order-upload'
    });
        

    isNotRegistered('payment-container') && (binding.modules['payment-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-payment-container' */
            'partner/modules/payment-container/payment-container.tsx'),
        $type: 'containerModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'invoiceAccountInfo',  path:'actions/get-invoice-account.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'payment-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/payment-container'
    });
        

    isNotRegistered('po-number') && (binding.modules['po-number'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-po-number' */
            'partner/modules/po-number/po-number.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'po-number',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/po-number'
    });
        

    isNotRegistered('promo-container') && (binding.modules['promo-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promo-container' */
            'partner/modules/promo-container/promo-container.tsx'),
        $type: 'containerModule',
        da: [{name:'customerFreightTerm',  path:'actions/get-customer-freight-term-code.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'promo-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/promo-container'
    });
        

    isNotRegistered('promo-option-container') && (binding.modules['promo-option-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promo-option-container' */
            'partner/modules/promo-option-container/promo-option-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'promo-option-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/promo-option-container'
    });
        

    isNotRegistered('reports-export') && (binding.modules['reports-export'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-reports-export' */
            'partner/modules/reports-export/reports-export.tsx'),
        $type: 'contentModule',
        da: [{name:'manufacturerCodes',  path:'actions/get-manufacturer-codes.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'reports-export',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/reports-export'
    });
        

    isNotRegistered('table-browser') && (binding.modules['table-browser'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-table-browser' */
            'partner/modules/table-browser/table-browser.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'table-browser',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/table-browser'
    });
        

        {   
            const actionPath = 'actions/b2b-get-products.action';
            binding.dataActions[actionPath] = require('partner/actions/b2b-get-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/cart-delivery-options-override.action';
            binding.dataActions[actionPath] = require('partner/actions/cart-delivery-options-override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-allowable-freight-calculation.action';
            binding.dataActions[actionPath] = require('partner/actions/get-allowable-freight-calculation.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-backorder-list.action';
            binding.dataActions[actionPath] = require('partner/actions/get-backorder-list.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-contract-list.action';
            binding.dataActions[actionPath] = require('partner/actions/get-contract-list.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-customer-freight-term-code.action';
            binding.dataActions[actionPath] = require('partner/actions/get-customer-freight-term-code.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-dealer-details.action';
            binding.dataActions[actionPath] = require('partner/actions/get-dealer-details.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-dealer-locations.action';
            binding.dataActions[actionPath] = require('partner/actions/get-dealer-locations.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-education-courses.action';
            binding.dataActions[actionPath] = require('partner/actions/get-education-courses.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-enhanced-description.action';
            binding.dataActions[actionPath] = require('partner/actions/get-enhanced-description.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-gdn-invoice-details.action';
            binding.dataActions[actionPath] = require('partner/actions/get-gdn-invoice-details.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-gdn-invoices.action';
            binding.dataActions[actionPath] = require('partner/actions/get-gdn-invoices.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-invoice-account.action';
            binding.dataActions[actionPath] = require('partner/actions/get-invoice-account.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-invoice-breakdown.action';
            binding.dataActions[actionPath] = require('partner/actions/get-invoice-breakdown.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-manufacturer-brand-name.action';
            binding.dataActions[actionPath] = require('partner/actions/get-manufacturer-brand-name.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-manufacturer-codes.action';
            binding.dataActions[actionPath] = require('partner/actions/get-manufacturer-codes.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-model-assembly.action';
            binding.dataActions[actionPath] = require('partner/actions/get-model-assembly.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-order-details-additional-info.action';
            binding.dataActions[actionPath] = require('partner/actions/get-order-details-additional-info.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-order-tracking-code.action';
            binding.dataActions[actionPath] = require('partner/actions/get-order-tracking-code.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-paginated-order-template-lines.action';
            binding.dataActions[actionPath] = require('partner/actions/get-paginated-order-template-lines.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-part-state.action';
            binding.dataActions[actionPath] = require('partner/actions/get-part-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-eligibility.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-eligibility.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-simple-products.override.action';
            binding.dataActions[actionPath] = require('partner/actions/get-simple-products.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-supersession-products.action';
            binding.dataActions[actionPath] = require('partner/actions/get-supersession-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/search-models.action';
            binding.dataActions[actionPath] = require('partner/actions/search-models.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('advanced-notes')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('allowable-freight')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('ari-search-results')){
            const sanitizedActionPath = 'actions/search-models.action';
            let dataAction = require('partner/actions/search-models.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('back-order-list')){
            const sanitizedActionPath = 'actions/get-backorder-list.action';
            let dataAction = require('partner/actions/get-backorder-list.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart-line-comment')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-section-container-w-payment-selector')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-section-container-w-payment-selector')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-section-container-w-payment-selector')){
            const sanitizedActionPath = 'actions/get-invoice-account.action';
            let dataAction = require('partner/actions/get-invoice-account.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('contracts-account-page')){
            const sanitizedActionPath = 'actions/get-contract-list.action';
            let dataAction = require('partner/actions/get-contract-list.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('education-training')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('education-training')){
            const sanitizedActionPath = 'actions/get-education-courses.action';
            let dataAction = require('partner/actions/get-education-courses.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-map')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-quick-order')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-quick-order')){
            const sanitizedActionPath = 'actions/get-manufacturer-codes.action';
            let dataAction = require('partner/actions/get-manufacturer-codes.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-search-result-container')){
            const sanitizedActionPath = 'modules/eve-search-result-container/actions/get-full-products-by-collection';
            let dataAction = require('partner/modules/eve-search-result-container/actions/get-full-products-by-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-search-result-container')){
            const sanitizedActionPath = 'modules/eve-search-result-container/actions/get-mapped-search-configuration';
            let dataAction = require('partner/modules/eve-search-result-container/actions/get-mapped-search-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-search-result-container')){
            const sanitizedActionPath = 'modules/eve-search-result-container/actions/get-refiners-for-collection';
            let dataAction = require('partner/modules/eve-search-result-container/actions/get-refiners-for-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('eve-search-result-container')){
            const sanitizedActionPath = 'modules/eve-search-result-container/list-page-state';
            let dataAction = require('partner/modules/eve-search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gardner-theme')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gardner-theme')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gardner-theme')){
            const sanitizedActionPath = 'actions/get-enhanced-description.action';
            let dataAction = require('partner/actions/get-enhanced-description.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gardner-theme')){
            const sanitizedActionPath = 'actions/get-invoice-account.action';
            let dataAction = require('partner/actions/get-invoice-account.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gardner-theme')){
            const sanitizedActionPath = 'actions/get-manufacturer-codes.action';
            let dataAction = require('partner/actions/get-manufacturer-codes.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gardner-theme')){
            const sanitizedActionPath = 'actions/get-order-details-additional-info.action';
            let dataAction = require('partner/actions/get-order-details-additional-info.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gardner-theme-b2c')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gardner-theme-b2c')){
            const sanitizedActionPath = 'actions/get-enhanced-description.action';
            let dataAction = require('partner/actions/get-enhanced-description.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-invoice-details')){
            const sanitizedActionPath = 'actions/get-gdn-invoice-details.action';
            let dataAction = require('partner/actions/get-gdn-invoice-details.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-invoices-list')){
            const sanitizedActionPath = 'actions/get-gdn-invoices.action';
            let dataAction = require('partner/actions/get-gdn-invoices.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-order-template')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-order-template')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-order-template')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-order-template')){
            const sanitizedActionPath = 'modules/gdn-order-template/actions/get-gdn-order-template';
            let dataAction = require('partner/modules/gdn-order-template/actions/get-gdn-order-template');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-product-specification')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-product-specification')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-additional-media-locations-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-additional-media-locations-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('gdn-product-specification')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('model-viewer')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('model-viewer')){
            const sanitizedActionPath = 'actions/get-manufacturer-brand-name.action';
            let dataAction = require('partner/actions/get-manufacturer-brand-name.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('model-viewer')){
            const sanitizedActionPath = 'actions/get-model-assembly.action';
            let dataAction = require('partner/actions/get-model-assembly.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history-search')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history-search')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history-search')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history-search')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history-search')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-level-comment')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-scheduler')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('payment-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('payment-container')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('payment-container')){
            const sanitizedActionPath = 'actions/get-invoice-account.action';
            let dataAction = require('partner/actions/get-invoice-account.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('po-number')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('promo-container')){
            const sanitizedActionPath = 'actions/get-customer-freight-term-code.action';
            let dataAction = require('partner/actions/get-customer-freight-term-code.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('reports-export')){
            const sanitizedActionPath = 'actions/get-manufacturer-codes.action';
            let dataAction = require('partner/actions/get-manufacturer-codes.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};